import { Stack, Typography } from '@mui/material'
import ShippingCompanyDetailsCard from '../ShippingCompanyDetailsCard'
import { useTranslation } from 'react-i18next'


export default function ShippingDetailsTab({
    order
}) {
    const { t } = useTranslation()

    return (
        <Stack spacing={2}>
            {!!order?.otoIntegration?.shipment?.deliveryOption &&
                <ShippingCompanyDetailsCard title={t("Delivery shipment details")} shipment={order?.otoIntegration?.shipment} otoIntegration={order?.otoIntegration} />
            }
            {!!order?.otoIntegration?.returnShipment?.deliveryOption &&
                <ShippingCompanyDetailsCard title={t("Return shipment details")} shipment={order?.otoIntegration?.returnShipment} otoIntegration={order?.otoIntegration} />
            }
            {
                (!order?.otoIntegration?.shipment?.deliveryOption && !order?.otoIntegration?.returnShipment?.deliveryOption) &&
                <Typography variant="h6" fontWeight="bold" color="text.lighter" textAlign="center">
                    {t("No shipping details available.")}
                </Typography>
            }
        </Stack>
    )
}
